/**
 * Represents the status of a MeditLink case.
 * @typedef {'FORM' | 'SCAN' | 'NEED_PROCESSING' | 'CAD' | 'CAM' | 'MILL' | 'COMPLETED'} MeditLinkCaseStatus
 * @property {'FORM'} FORM - The case is in the form stage.
 * @property {'SCAN'} SCAN - The case is in the scan stage.
 * @property {'NEED_PROCESSING'} NEED_PROCESSING - The case needs processing.
 * @property {'CAD'} CAD - The case is in the CAD stage.
 * @property {'CAM'} CAM - The case is in the CAM stage.
 * @property {'MILL'} MILL - The case is in the mill stage.
 * @property {'COMPLETED'} COMPLETED - The case is completed.
 */

export const MeditLinkCaseStatus = {
    FORM: 'FORM',
    SCAN: 'SCAN',
    NEED_PROCESSING: 'NEED_PROCESSING',
    CAD: 'CAD',
    CAM: 'CAM',
    MILL: 'MILL',
    COMPLETED: 'COMPLETED',
};

/**
 * @typedef {Object} MedictLinkPatient
 * @property {string} name
 * @property {string} code 


/**
 * @typedef {Object} MedictLinkFileData
 * @property {string} name
 * @property {number} size 
 * @property {string} uuid
 * @property {number} dateUpdated 
 * @property {string} dateCreated
 * @property {number} fileType 
 * @property {date} dateExpired
 * @property {string} schemaVersion 
 * @property {string} url
 * @property {string} downloadFileName 
/**

 /** CaseInfo's data.
 * @typedef {Object} MedictLinkCaseInfo
 * @property {date} dateUpdated
 * @property {date} dateCreated 
 * @property {date} dateScanned 
 * @property {string} uuid 
 * @property {string} name 
 * @property {MeditLinkCaseStatus} status 
 * @property {string[]} tags
 * @property {MedictLinkPatient} patient 
 * @property {MedictLinkFileData[]} files 
 * @property {string[]} multiOcclusionGroup 
 * @property {number[]} bridges 
 * @property {string} schemaVersion 
 * @property {object} formInformation 
 */

export const MedictLinkCaseInfo = {};

/** MedictLink CaseInfo's data.
 * @typedef {Object} MedictLinkCaseInfoData
 * @property {MedictLinkCaseInfo} caseInfo
 * @property {object} error
 */

export const MedictLinkCaseInfoData = {};
